import {inject} from "@angular/core";
import {CanActivateFn, Params, Router} from "@angular/router";
import {SimUserExtendedService, SimWebpagePermissionService} from "@services";
import {RouteData} from "../../app-routing.models";

export const cookieGuard: CanActivateFn = async (route, state) => {
	const userService = inject(SimUserExtendedService);
	const router = inject(Router);
	const simWebpagePermissionService = inject(SimWebpagePermissionService);

	//we only check permissions on component routes
	if (!route.component) return true;

	const data = route.data as RouteData;
	const customRedirect = data.customRedirect;

	console.debug(state.url, data);

	const user = await userService.init();
	// Check if user is authenticated
	if (!userService.isAnonymous(user) && userService.hasValidToken()) {
		// Check if user has permissions to view the page
		const hasPermission = simWebpagePermissionService.hasPermission(state.url);
		return hasPermission
			? true
			: redirectTo(router, customRedirect, {
					error: "403",
					redirectTo: state.url,
				});
	} else {
		// prevent "not logged in" message for initial dashboard redirect
		const error = state.url == "/event-dashboard" ? null : "401";
		return redirectTo(router, customRedirect, {
			error: error,
			redirectTo: state.url,
		});
	}
};

async function redirectTo(router: Router, customRedirect: string | undefined, params: Params): Promise<boolean> {
	const redirect = customRedirect ?? "login";
	return router
		.navigate([redirect], {
			queryParams: params,
		})
		.then(() => false);
}
